import { render, staticRenderFns } from "./PremiumAvatar.vue?vue&type=template&id=df06ccd8&scoped=true"
import script from "./PremiumAvatar.vue?vue&type=script&lang=js"
export * from "./PremiumAvatar.vue?vue&type=script&lang=js"
import style0 from "./PremiumAvatar.vue?vue&type=style&index=0&id=df06ccd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df06ccd8",
  null
  
)

export default component.exports